/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Dual_Charger_TitleInputs */

const en_dispatch_dual_charger_title = /** @type {(inputs: Dispatch_Dual_Charger_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dual role: this waypoint is also a charger`)
};

const fr_dispatch_dual_charger_title = /** @type {(inputs: Dispatch_Dual_Charger_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double rôle : ce waypoint sert aussi de point de charge`)
};

const ms_sg2_dispatch_dual_charger_title = /** @type {(inputs: Dispatch_Dual_Charger_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peranan ganda: titik laluan ini juga merupakan stesen pengecas`)
};

/**
* | output |
* | --- |
* | "Dual role: this waypoint is also a charger" |
*
* @param {Dispatch_Dual_Charger_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_dual_charger_title = /** @type {((inputs?: Dispatch_Dual_Charger_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Dual_Charger_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_dual_charger_title(inputs)
	if (locale === "fr") return fr_dispatch_dual_charger_title(inputs)
	return ms_sg2_dispatch_dual_charger_title(inputs)
});